import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import * as style from './SimpleInfoItem.css';

export interface ISimpleInfoItemProps {
  title: string;
  value: string;
}

export const SimpleInfoItem: React.FC<ISimpleInfoItemProps> = ({ title, value }) => {
  return (
    <div className={style['container']}>
      <ArticleParagraph2 color="text-secondary-default">{title}</ArticleParagraph2>
      <ArticleParagraph2 color="text-primary-default" fontWeight={'bold'}>
        {value}
      </ArticleParagraph2>
    </div>
  );
};
